import { Box, Text } from '@chakra-ui/react'
import React from 'react'

export const ModalFinanceiro = () => {
  return (
    <Box mt='1rem' w='100%'>
      <Text color='red'>Limite de Crédito Liberado</Text>
      <Text fontFamily='Akrobat Extrabold' ml='1rem'>R$ 50.000,00</Text>
    </Box>
  )
}
